import { Expression_Editor } from "./bfm_expression_editor";
import React, { useCallback, useEffect, useState, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import * as utils from "../../../components/utils.js";

const IF_Editor = ({ node, schemas, onChange }) => {
    const [item, setItem] = useState(node);

    const _notifyChange = () => {
        if (onChange) {
            onChange(item);
        }
    }

    useEffect(() => {
        console.log(item);
    }, [item]);

    return (
        <div>
            <div class="form-group">
                <label for="if_editor_name">Name</label>
                <input type="text" className="form-control" id="if_editor_name" aria-describedby="emailHelp" placeholder="Enter the name"
                    value={item.name} onChange={(e) => {
                        item.name = e.target.value;
                        setItem(utils.clone(item));
                        _notifyChange();
                    }}
                />
                <small id="if_editor_name_help" className="form-text text-muted">Name as seen in the flow editor</small>
            </div>
            <hr></hr>
            <div class="form-group">
                <label for="if_expression_editor">Expression</label>
                <Expression_Editor schemas={schemas} query={item.expression} onChange={(q) => {
                    item.expression = q;
                    setItem(utils.clone(item));
                    _notifyChange();
                }} />
            </div>
        </div>);
}

export { IF_Editor }